import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ApiService } from '../../app/services/api.service';
import { Localization } from '../../app/app.localization';
import { Config } from '../../app/app.config';
import { CustomModalComponent } from '../../components/custom-modal/custom-modal';
import { ConfirmOrderModalComponent } from '../../components/confirm-order-modal/confirm-order-modal';

@Component({
  selector: 'page-resend-mail',
  templateUrl: 'resend-mail.html',
})
export class ResendMailPage {

  commerceHTML: SafeHtml;
  rootPage: any;
  submit: any;
  storeName: any;
  mobile_email: any;
  mobile_sms: any;
  guide: any;
  info: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private sanitizer: DomSanitizer,
    private _apiService: ApiService,
    private modalCtrl: ModalController,
    private _loc: Localization
  ) {
      this.storeName = localStorage.getItem("storeName");
      this.guide = JSON.parse(localStorage.getItem('configs'))["MOBILEORDER_RESEND_MAIL_GUIDE"];
      this.guide = (this.guide) ? JSON.parse(this.guide) : "";
      this.info = (this.guide && this.guide.info) ? this.guide.info : this._loc.t('※30日以内の全ての注文完了メールが再送されます。\n※それ以前の注文は別途問い合わせください。\n※メールが届かない場合は注文店舗やドメインの設定を確認してください。\n※再送前にnoreply@okagekk.comからメールが受信できるよう設定をお願いします。\n※メールが届かない場合は<a href="mailto:support@31info.jp?subject=%E3%83%8D%E3%83%83%E3%83%88%E4%BA%88%E7%B4%84%E3%81%AB%E9%96%A2%E3%81%99%E3%82%8B%E3%81%8A%E5%95%8F%E3%81%84%E5%90%88%E3%82%8F%E3%81%9B&body=%E2%80%BB%E3%81%93%E3%81%A1%E3%82%89%E3%81%AE%E3%83%A1%E3%83%BC%E3%83%AB%E3%81%A7%E3%81%AF%E6%B3%A8%E6%96%87%E3%81%AF%E5%8F%97%E3%81%91%E4%BB%98%E3%81%91%E3%81%A6%E3%81%8A%E3%82%8A%E3%81%BE%E3%81%9B%E3%82%93%0D%0A%0D%0A%E3%81%8A%E5%95%8F%E3%81%84%E5%90%88%E3%82%8F%E3%81%9B%E3%81%82%E3%82%8A%E3%81%8C%E3%81%A8%E3%81%86%E3%81%94%E3%81%96%E3%81%84%E3%81%BE%E3%81%99%E3%80%82%0D%0A%E4%BB%A5%E4%B8%8B%E3%81%AE%E6%83%85%E5%A0%B1%E3%82%92%E3%81%94%E8%A8%98%E5%85%A5%E3%81%AE%E4%B8%8A%E3%81%8A%E5%95%8F%E3%81%84%E5%90%88%E3%82%8F%E3%81%9B%E3%81%8F%E3%81%A0%E3%81%95%E3%81%84%E3%80%82%0D%0A%E3%81%AA%E3%81%8A%E3%83%A1%E3%83%BC%E3%83%AB%E3%81%A7%E3%81%AE%E3%81%94%E5%9B%9E%E7%AD%94%E3%81%A8%E3%81%AA%E3%82%8A%E3%81%BE%E3%81%99%E3%81%AE%E3%81%A7%E3%80%81%4031info.jp%E3%81%8B%E3%82%89%E3%81%AE%E3%83%A1%E3%83%BC%E3%83%AB%E3%82%92%E5%8F%97%E4%BF%A1%E3%81%A7%E3%81%8D%E3%82%8B%E8%A8%AD%E5%AE%9A%0D%0A%E3%81%AB%E3%81%AA%E3%81%A3%E3%81%A6%E3%81%84%E3%82%8B%E3%81%8B%E3%82%92%E4%BB%8A%E4%B8%80%E5%BA%A6%E3%81%94%E7%A2%BA%E8%AA%8D%E3%81%8F%E3%81%A0%E3%81%95%E3%81%84%E3%80%82%0D%0A%0D%0A%E2%96%A0%E3%81%8A%E5%90%8D%E5%89%8D%0D%0A%0D%0A%E2%96%A0%E3%81%94%E4%BA%88%E7%B4%84%E6%89%8B%E7%B6%9A%E6%97%A5%E6%99%82%0D%0A%0D%0A%E2%96%A0%E5%BA%97%E8%88%97%0D%0A%0D%0A%E2%96%A0%E5%95%86%E5%93%81%E3%83%BB%E6%95%B0%E9%87%8F%0D%0A%0D%0A%E2%96%A0%E7%99%BB%E9%8C%B2%E9%9B%BB%E8%A9%B1%E7%95%AA%E5%8F%B7%0D%0A%0D%0A%E2%96%A0%E7%99%BB%E9%8C%B2%E3%83%A1%E3%83%BC%E3%83%AB%E3%82%A2%E3%83%89%E3%83%AC%E3%82%B9%0D%0A%0D%0A%E2%96%A0%E3%81%8A%E5%95%8F%E3%81%84%E5%90%88%E3%82%8F%E3%81%9B%E5%86%85%E5%AE%B9">support@31info.jp</a>までお問い合わせください。');
      this.info += (this.guide && this.guide.mailto) ? this.guide.mailto : "";
      this.submit = false;
      this.mobile_email = "";
      this.mobile_sms = "";
  }

  validateInput(showErrorMessage = false) {
    var modalSubTitle = [];

    if (this.mobile_email == "") {
      modalSubTitle.push(this._loc.t('・'+'メールアドレスを入力してください'));
    }

    if (this.mobile_email !== "" && !this.mobile_email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
      modalSubTitle.push(this._loc.t('・'+'メールアドレスは半角英数字・記号で入力してください'));
    }

    if (this.mobile_sms == "") {
      modalSubTitle.push(this._loc.t('・'+'電話番号を入力してください'));
    }

    if (this.mobile_sms !== "" && this.mobile_sms.length > 0 && this.mobile_sms.match(/[^0-9]+/)) {
      modalSubTitle.push(this._loc.t('・'+'電話番号は半角数字(ハイフン無し)で入力してください'));
    } else if (this.mobile_sms !== "" && !this.mobile_sms.match(/^0\d{9,10}$/)) {
      modalSubTitle.push(this._loc.t('・'+'電話番号を正しく入力してください')); // 桁数チェック
    }

    if (modalSubTitle.length == 0) {
      this.submit = true;
    } else {
      this.submit = false;
    }
    return modalSubTitle;
  }

  clickResendMail() {
    var validateModalSubTitle = this.validateInput();
    if (validateModalSubTitle.length > 0) {
      const modal = this.modalCtrl.create(ConfirmOrderModalComponent, { title: this._loc.t('必須項目を入力してください'), subTitles: validateModalSubTitle, bottomButton: this._loc.t('OK')  }, { showBackdrop: false, enableBackdropDismiss: false });
      modal.present();
    } else {
      var json = {
        store_id: localStorage.getItem("store_id"),
        mobile_email: this.mobile_email.replace(/\+/g, '%2B'),
        mobile_sms: this.mobile_sms,
        uiid: Config.uiid
      };

      if (localStorage.getItem("reserved") == "1") {
        json["reserved"] = 1;
      }
      var modalTitle = (this.guide && this.guide.title) ? this.guide.title : this._loc.t('メールの再送を受付ました');
      var modalSubTitle = (this.guide && this.guide.body) ? this.guide.body : this._loc.t('メールが届かない場合は迷惑メールフォルダーに入っている可能性があります。メールの受信設定をご確認ください。');
      const modal = this.modalCtrl.create(CustomModalComponent, { title: modalTitle, subTitle: modalSubTitle, bottomButton: this._loc.t('OK')  }, { showBackdrop: false, enableBackdropDismiss: false });
      modal.present();
      this._apiService.resendMail(json).subscribe(
        (result) => {
          //if (parseInt(result.status, 0) == (1000 || 901)) {
            // var modalTitle = (this.guide && this.guide.title) ? this.guide.title : this._loc.t('メールの再送を受付ました');
            // var modalSubTitle = (this.guide && this.guide.body) ? this.guide.body : this._loc.t('メールが届かない場合は迷惑メールフォルダーに入っている可能性があります。メールの受信設定をご確認ください。');
            // const modal = this.modalCtrl.create(CustomModalComponent, { title: modalTitle, subTitle: modalSubTitle, bottomButton: this._loc.t('OK')  }, { showBackdrop: false, enableBackdropDismiss: false });
            // modal.present();
          //} 
          // 注文がない時の対応、不要ということでコメントアウト。使う場合は95行目も修正する。
          // else if (parseInt(result.status, 0) == 901) {
          //   var modalTitle = this._loc.t('注文がありません');
          //   var modalSubTitle = this._loc.t('入力したメールアドレス、電話番号の注文が見つかりません。ご確認ください。');
          //   const modal = this.modalCtrl.create(CustomModalComponent, { title: modalTitle, subTitle: modalSubTitle, bottomButton: this._loc.t('OK')  }, { showBackdrop: false, enableBackdropDismiss: false });
          //   modal.present();
          // }
          // else {
          //   var modalTitle = (this.guide && this.guide.title) ? this.guide.title : this._loc.t('メールの送信に失敗しました。');
          //   var modalSubTitle = (this.guide && this.guide.body) ? this.guide.body : this._loc.t('メールの送信に失敗しました。再度送信してください。');
          //   const modal = this.modalCtrl.create(CustomModalComponent, { title: modalTitle, subTitle: modalSubTitle, bottomButton: this._loc.t('OK')  }, { showBackdrop: false, enableBackdropDismiss: false });
          //   modal.present();
          // }
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/resend-mail/resend-mail.ts